import { styled } from "styled-components";

export const Amount = styled.span<{ amount: number }>`
  color: ${({ amount, theme }) => (amount ? theme.colors.text : theme.colors.textDisabled)};
  // color: #62d28f;
  display: flex;
  align-items: center;
  font-size: 20px;
`;
